import { useApiQuery } from '@/shared/hooks/useApi';
import { api } from '@/shared/services/api';

import { CategoryItem } from '../types/productTypes';

const fetchCategories = async () => {
  return api.get<CategoryItem[]>('/api/v1/category');
};

export const useCategories = () => {
  return useApiQuery(['categories'], fetchCategories, {
    staleTime: 1000 * 60 * 10,
  });
};
